module.exports = __webpack_public_path__ + "b8fcd17b153f5cd52a547e7a609f6982.jpg";